import React from 'react';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

const RecoveryServiceToggle = ({ checked, onCheckedChange, disabled }) => (
  <div className="rounded-lg border border-amber-200 bg-amber-50 p-4 space-y-2">
    <div className="flex items-center justify-between gap-4">
      <div>
        <Label htmlFor="recovery-service-toggle" className="text-base font-semibold text-amber-900">
          ¿Es un servicio de recuperación de vehículo?
        </Label>
        <p className="text-sm text-amber-800 mt-1">
          Al activarlo se añade automáticamente la tarifa de recuperación según la zona del trayecto.
        </p>
      </div>
      <Switch
        id="recovery-service-toggle"
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
      />
    </div>
  </div>
);

export default RecoveryServiceToggle;
